import { useToast } from "@chakra-ui/react";
import { useCallback } from "react";
import { ScrollRestoration, useNavigate, useParams } from "react-router-dom";
import BasePage from "../common/BasePage";
import { useTranslation } from "react-i18next";
import QuizForm from "../../components/forms/QuizForm";

type Params = {
  lessonId: string;
};

export default function NewQuizPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toast = useToast();
  const { lessonId } = useParams<Params>();
  const onSuccess = useCallback(
    (createdLessonId: number) => {
      navigate(`../${createdLessonId}`);
      toast({
        title: t("new_quiz_page.quiz_created"),
        description: t("new_quiz_page.quiz_created_message"),
        status: "success",
        isClosable: true,
      });
    },
    [navigate, t, toast],
  );

  const onError = useCallback(() => {
    toast({
      title: t("new_quiz_page.quiz_error"),
      description: t("new_quiz_page.quiz_error_message"),
      status: "error",
      isClosable: true,
    });
  }, [t, toast]);

  return (
    <BasePage title={t("new_quiz_page.new_quiz")}>
      <ScrollRestoration />
      <QuizForm lessonId={lessonId} onSuccess={onSuccess} onError={onError} />
    </BasePage>
  );
}
